import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import classNames from 'classnames';

import { DSIcon } from '../../../base';
import Tooltip from '../Tooltip/Tooltip';

import styles from './Scoring.module.scss';

const ICON_SIZE = {
  small: 'sm',
  medium: 'm',
  large: 'ml',
  huge: 'ml'
};

const Scoring = ({
  score,
  totalReviews,
  className = '',
  size = 'small',
  bold = true,
  tooltipPosition = 'left'
}) => {
  const classes = classNames(styles['scoring__content-wrapper']);
  const textClassName = classNames(
    styles.scoring__content,
    styles[`scoring__content--${size}`],
    {
      [styles['scoring__content--bold']]: bold
    },
    className
  );

  const scoreValue = score / 100;

  const tooltipText = (
    <span
      dangerouslySetInnerHTML={{
        __html: trans('scoring-tooltip', { totalReviews })
      }}
    />
  );

  return (
    <Tooltip
      color="tertiary"
      tooltip={tooltipText}
      className={styles.scoring__tooltip}
      textClassName={styles['scoring__tooltip-text']}
      trigger={['click', 'hover']}
      position={tooltipPosition}
      smartPosition={false}
    >
      <div className={classes}>
        <DSIcon name="star" size={ICON_SIZE[size] || 'sm'} />
        <span
          className={textClassName}
        >{`${scoreValue} (${totalReviews})`}</span>
      </div>
    </Tooltip>
  );
};

Scoring.propTypes = {
  score: PropTypes.number.isRequired,
  totalReviews: PropTypes.number.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'huge']),
  bold: PropTypes.bool,
  tooltipPosition: PropTypes.oneOf(['left', 'right', 'top', 'bottom'])
};

export default Scoring;
